/* eslint-disable camelcase */
import React, {useState, useEffect} from 'react'
import {Link} from 'gatsby'
import {css} from '@emotion/core'
import Layout from '../components/Layout'
import {getTheme, getThemeStyles} from '../util/theme'

const site = {
    allSitePage: {
        edges: [
            {
                node: {
                    path: '/dev-404-page/',
                },
            },
            {
                node: {
                    path: '/404/',
                },
            },
            {
                node: {
                    path: '/about-us/',
                },
            },
            {
                node: {
                    path: '/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/advanced-search/',
                },
            },
            {
                node: {
                    path: '/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/captcha-block/',
                },
            },
            {
                node: {
                    path: '/captcha/',
                },
            },
            {
                node: {
                    path: '/errors/',
                },
            },
            {
                node: {
                    path: '/eula/',
                },
            },
            {
                node: {
                    path: '/feedback/',
                },
            },
            {
                node: {
                    path: '/firefox/',
                },
            },
            {
                node: {
                    path: '/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/',
                },
            },
            {
                node: {
                    path: '/make-homepage/',
                },
            },
            {
                node: {
                    path: '/notfound/',
                },
            },
            {
                node: {
                    path: '/off-line/',
                },
            },
            {
                node: {
                    path: '/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/verify/',
                },
            },
            {
                node: {
                    path: '/da/about-us/',
                },
            },
            {
                node: {
                    path: '/da/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/da/advanced-search/',
                },
            },
            {
                node: {
                    path: '/da/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/da/errors/',
                },
            },
            {
                node: {
                    path: '/da/eula/',
                },
            },
            {
                node: {
                    path: '/da/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/da/make-homepage/',
                },
            },
            {
                node: {
                    path: '/da/notfound/',
                },
            },
            {
                node: {
                    path: '/da/off-line/',
                },
            },
            {
                node: {
                    path: '/da/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/da/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/de/about-us/',
                },
            },
            {
                node: {
                    path: '/de/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/de/advanced-search/',
                },
            },
            {
                node: {
                    path: '/de/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/de/errors/',
                },
            },
            {
                node: {
                    path: '/de/eula/',
                },
            },
            {
                node: {
                    path: '/de/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/de/make-homepage/',
                },
            },
            {
                node: {
                    path: '/de/notfound/',
                },
            },
            {
                node: {
                    path: '/de/off-line/',
                },
            },
            {
                node: {
                    path: '/de/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/de/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/en/about-us/',
                },
            },
            {
                node: {
                    path: '/en/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/en/advanced-search/',
                },
            },
            {
                node: {
                    path: '/en/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/en/errors/',
                },
            },
            {
                node: {
                    path: '/en/eula/',
                },
            },
            {
                node: {
                    path: '/en/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/en/make-homepage/',
                },
            },
            {
                node: {
                    path: '/en/notfound/',
                },
            },
            {
                node: {
                    path: '/en/off-line/',
                },
            },
            {
                node: {
                    path: '/en/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/en/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/en/terms/',
                },
            },
            {
                node: {
                    path: '/es/about-us/',
                },
            },
            {
                node: {
                    path: '/es/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/es/advanced-search/',
                },
            },
            {
                node: {
                    path: '/es/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/es/errors/',
                },
            },
            {
                node: {
                    path: '/es/eula/',
                },
            },
            {
                node: {
                    path: '/es/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/es/make-homepage/',
                },
            },
            {
                node: {
                    path: '/es/notfound/',
                },
            },
            {
                node: {
                    path: '/es/off-line/',
                },
            },
            {
                node: {
                    path: '/es/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/es/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/fr/about-us/',
                },
            },
            {
                node: {
                    path: '/fr/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/fr/advanced-search/',
                },
            },
            {
                node: {
                    path: '/fr/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/fr/errors/',
                },
            },
            {
                node: {
                    path: '/fr/eula/',
                },
            },
            {
                node: {
                    path: '/fr/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/fr/make-homepage/',
                },
            },
            {
                node: {
                    path: '/fr/notfound/',
                },
            },
            {
                node: {
                    path: '/fr/off-line/',
                },
            },
            {
                node: {
                    path: '/fr/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/fr/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/ja/about-us/',
                },
            },
            {
                node: {
                    path: '/ja/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/ja/advanced-search/',
                },
            },
            {
                node: {
                    path: '/ja/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/ja/errors/',
                },
            },
            {
                node: {
                    path: '/ja/eula/',
                },
            },
            {
                node: {
                    path: '/ja/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/ja/make-homepage/',
                },
            },
            {
                node: {
                    path: '/ja/notfound/',
                },
            },
            {
                node: {
                    path: '/ja/off-line/',
                },
            },
            {
                node: {
                    path: '/ja/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/ja/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/ja/terms/',
                },
            },
            {
                node: {
                    path: '/nl/about-us/',
                },
            },
            {
                node: {
                    path: '/nl/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/nl/advanced-search/',
                },
            },
            {
                node: {
                    path: '/nl/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/nl/errors/',
                },
            },
            {
                node: {
                    path: '/nl/eula/',
                },
            },
            {
                node: {
                    path: '/nl/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/nl/make-homepage/',
                },
            },
            {
                node: {
                    path: '/nl/notfound/',
                },
            },
            {
                node: {
                    path: '/nl/off-line/',
                },
            },
            {
                node: {
                    path: '/nl/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/nl/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/no/about-us/',
                },
            },
            {
                node: {
                    path: '/no/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/no/advanced-search/',
                },
            },
            {
                node: {
                    path: '/no/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/no/errors/',
                },
            },
            {
                node: {
                    path: '/no/eula/',
                },
            },
            {
                node: {
                    path: '/no/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/no/make-homepage/',
                },
            },
            {
                node: {
                    path: '/no/notfound/',
                },
            },
            {
                node: {
                    path: '/no/off-line/',
                },
            },
            {
                node: {
                    path: '/no/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/no/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/pl/about-us/',
                },
            },
            {
                node: {
                    path: '/pl/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/pl/advanced-search/',
                },
            },
            {
                node: {
                    path: '/pl/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/pl/errors/',
                },
            },
            {
                node: {
                    path: '/pl/eula/',
                },
            },
            {
                node: {
                    path: '/pl/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/pl/make-homepage/',
                },
            },
            {
                node: {
                    path: '/pl/notfound/',
                },
            },
            {
                node: {
                    path: '/pl/off-line/',
                },
            },
            {
                node: {
                    path: '/pl/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/pl/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/pt/about-us/',
                },
            },
            {
                node: {
                    path: '/pt/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/pt/advanced-search/',
                },
            },
            {
                node: {
                    path: '/pt/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/pt/errors/',
                },
            },
            {
                node: {
                    path: '/pt/eula/',
                },
            },
            {
                node: {
                    path: '/pt/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/pt/make-homepage/',
                },
            },
            {
                node: {
                    path: '/pt/notfound/',
                },
            },
            {
                node: {
                    path: '/pt/off-line/',
                },
            },
            {
                node: {
                    path: '/pt/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/pt/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/sv/about-us/',
                },
            },
            {
                node: {
                    path: '/sv/add-startpage-com-to-your-home-screen/',
                },
            },
            {
                node: {
                    path: '/sv/advanced-search/',
                },
            },
            {
                node: {
                    path: '/sv/anonymous-view/',
                },
            },
            {
                node: {
                    path: '/sv/errors/',
                },
            },
            {
                node: {
                    path: '/sv/eula/',
                },
            },
            {
                node: {
                    path: '/sv/how-startpage-works/',
                },
            },
            {
                node: {
                    path: '/sv/make-homepage/',
                },
            },
            {
                node: {
                    path: '/sv/notfound/',
                },
            },
            {
                node: {
                    path: '/sv/off-line/',
                },
            },
            {
                node: {
                    path: '/sv/privacy-policy/',
                },
            },
            {
                node: {
                    path: '/sv/support-privacy-policy/',
                },
            },
            {
                node: {
                    path: '/404.html',
                },
            },
        ],
    },
}

const IndexPage = () => {
    const allRoutes = site.allSitePage.edges.map((edge) => edge.node.path)
    const unLocalized = allRoutes.filter((route) => route.split('/').length <= 3).sort()
    const localized = allRoutes.filter((route) => route.split('/').length > 3).sort()

    const routesList = (routesList) => {
        return routesList.map((route, i) => {
            return (
                <div key={i}>
                    <Link
                        to={route}
                        css={css`
                            color: blue;
                        `}
                    >
                        {route}
                    </Link>
                </div>
            )
        })
    }

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})

    useEffect(() => {
        const theme = getTheme()
        const themeStyles = getThemeStyles()
        setTheme(theme)
        setThemeStyles(themeStyles)
    }, [themeStyles])

    return (
        <Layout
            title="startpage-static-pages"
            description="index page for startpage-static-pages"
            canonicalPath="/"
            themeStyles={themeStyles}
            noHeaderFooter
            theme={theme}
        >
            <div
                css={css`
                    background: #fff;
                    padding: 1rem 1rem 4rem;
                `}
            >
                <h1
                    css={css`
                        margin: 1rem 0 2rem;
                    `}
                >
                    Startpage Static Pages
                </h1>
                <div
                    css={css`
                        padding-left: 2rem;
                        h2 {
                            margin: 1.5rem 0;
                        }
                    `}
                >
                    <h2>pages</h2>
                    <div>{routesList(unLocalized)}</div>

                    <h2>localized pages</h2>
                    <div>{routesList(localized)}</div>
                </div>
            </div>
        </Layout>
    )
}

export default IndexPage
